import api from './api';

export const docsService = {
  async getOpenApiSpec() {
    const response = await api.get('/docs/openapi.json');
    return response.data;
  },
};
